var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import ReactHtmlParser from "react-html-parser";
import { useEffect, useMemo } from "react";
import layoutComponentsDictionary from "@/components/forms/components/layout/layoutComponentsDictionary";
import { useGetRemindersQuery } from "@/store/api";
/** <b>Composant en mode consultation/detail d'un champ de type function</b>*/
export default function RemindersDetail(_a) {
    var fieldName = _a.fieldName, fieldDef = _a.fieldDef, moduleName = _a.moduleName, onUpdate = _a.onUpdate, record = _a.record;
    var recordId = fieldDef["id"]["value"];
    var remindersResponse = useGetRemindersQuery({
        moduleName: moduleName,
        recordId: recordId,
    }).data;
    var saveReminder = (remindersResponse === null || remindersResponse === void 0 ? void 0 : remindersResponse.data) || [];
    var reminders = (saveReminder === null || saveReminder === void 0 ? void 0 : saveReminder.remindersData) || [];
    useEffect(function () {
        record.id && onUpdate && onUpdate(__assign(__assign({}, record), { reminders: reminders }));
    }, [remindersResponse]);
    var value = useMemo(function () {
        if (!fieldDef[fieldName]["value"]) {
            return;
        }
        return fieldDef[fieldName]["value"] || "";
    }, [fieldName, fieldDef]);
    return _jsx("div", __assign({ className: "function-edit" }, { children: ReactHtmlParser(value) }));
}
layoutComponentsDictionary.registerLayoutComponent("reminders-detail", RemindersDetail);
